<script>
	import Footer from "./components/Footer.svelte";
	import Header from "./components/Header.svelte";
	
	import Index from "./views/Index.svelte";
</script>

<div class="main">
	<Header />
	<Index />
	<Footer />
</div>

<style>
	.main {
		min-height: 100%;
		max-width: 768px;
		margin: 0 auto;
		background: #fff;
	}
</style>